module.exports = __webpack_public_path__ + "img/googlePlayLight.cdef8b24.svg";